export const parseNumbers = (input: string): number[] => {
  if (!input) return [];

  const result = new Set();
  const parts = input.split(',').map((part) => part.trim());

  for (const part of parts) {
    if (part.includes('-')) {
      const [start, end] = part.split('-').map((num) => parseInt(num.trim()));
      if (!isNaN(start) && !isNaN(end) && start < end) {
        for (let i = start; i <= end; i++) {
          result.add(i);
        }
      }
    } else {
      const num = parseInt(part);
      if (!isNaN(num)) {
        result.add(num);
      }
    }
  }

  return (Array.from(result) as number[]).sort((a, b) => a - b);
};
